import { render, staticRenderFns } from "./ChecklistItemB.vue?vue&type=template&id=f3cb47a6"
import script from "./ChecklistItemB.vue?vue&type=script&lang=js"
export * from "./ChecklistItemB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports